// ©2024 Austin App House. All rights reserved.
import React from 'react';
import PaymentMethodCard from './PaymentMethodCard';

const PaymentMethodsList = ({
  paymentMethods = [], editPaymentMethod, deletePaymentMethod, makePrimary, auth,
}) => {
  if (!paymentMethods?.length) {
    return null;
  }

  return (
    <>
      <h2 className="subpage-section-title">Bank Info</h2>
      <div className="payment-methods-list">
        {paymentMethods.map(paymentMethod => (
          <PaymentMethodCard
            key={paymentMethod.id}
            paymentMethod={paymentMethod}
            editPaymentMethod={editPaymentMethod}
            deletePaymentMethod={deletePaymentMethod}
            makePrimary={makePrimary}
            auth={auth}
          />
        ))}
      </div>
    </>
  );
};

export default PaymentMethodsList;
